import { trigger, state, animate, transition, style } from '@angular/animations';

export const FADE_IN_OUT_ANIMATION = trigger('fadeInOutAnimation', [
	transition(":enter", [
		style({ opacity: 0 }),
		animate('.5s', style({ opacity: 1 }))
	]),
	transition(":leave", [
		animate('.1s', style({ opacity: 0 }))
	])
]);


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/animations/fade-in-out.ts